for (const container of document.querySelectorAll(
  ".location-map"
) as NodeListOf<HTMLElement> as any) {
  const geoLocationBtn = <HTMLElement>(
    container.querySelector(".location-map__search__form__location")
  );

  geoLocationBtn?.addEventListener("click", function (e) {
    if ("geolocation" in navigator) {
      e.preventDefault();

      navigator.geolocation.getCurrentPosition((position) => {
        const urlParams = new URLSearchParams(window.location.search);

        urlParams.set("latitude", position.coords.latitude.toString());
        urlParams.set("longitude", position.coords.longitude.toString());
        urlParams.delete("target");

        window.location.hash = container.getAttribute("id");
        window.location.search = urlParams.toString();
      });
    }
  });

  window.addEventListener("load", function (e) {
    const mapId = <string>container.querySelector(".gm-map").getAttribute("id");
    const map = mapId ? window.googleMaps.getMap(mapId) : null;

    if (map) {
      for (const mapResult of container.querySelectorAll(
        ".location-map__search__result"
      ) as NodeListOf<HTMLElement> as any) {
        mapResult?.addEventListener("click", function (this: HTMLElement) {
          const lat = this.getAttribute("data-lat");
          const lng = this.getAttribute("data-lng");
          const markerId = this.getAttribute("data-marker-id");

          if (lat && lng) {
            // Zoom closer to the map on click
            map.zoom(15);

            // Center the map to current marker
            map.center({
              lat: lat,
              lng: lng,
            });

            // close all opened marker tooltips
            for (const closeBtn of container.querySelectorAll(
              ".gm-map button[aria-label='Close']"
            ) as NodeListOf<HTMLElement> as any) {
              closeBtn?.click();
            }

            // open this specific marker tooltip
            map.openInfoWindow(markerId);

            // remove active class to other results
            for (const activeResult of container.querySelectorAll(
              ".location-map__search__result.active"
            ) as NodeListOf<HTMLElement> as any) {
              activeResult?.classList.remove("active");
            }

            // add active class to current result
            this.classList.add("active");
          }
        });
      }
    }
  });
}
